$(function () {
    new InlineTimePicker();
});

class InlineTimePicker {

    constructor($element) {
        if ($element) {
            this.create($element);
        } else {
            this.findAll();
        }
    }

    findAll() {

        let that = this;
        $('[data-component="inlineTimePicker"]').each(function () {
            if (!$(this).hasClass('inlineTimePicker-element')) {
                that.create($(this));
            }
        })
    }

    create($element) {
        let that = this;
        let $container = that.create__Container();

        let $hour = that.create__Input('hour');
        let $dots = that.create__Input('dots');
        let $minute = that.create__Input('minute');

        let $upArrow = that.create__Arrow('up');
        let $downArrow = that.create__Arrow('down');

        $element
            .addClass('inlineTimePicker-element')
            .wrap($container);

        $container = $element.parent('.inlineTimePicker');

        $container.append($hour);
        $container.append($dots);
        $container.append($minute);
        $container.append($upArrow);
        $container.append($downArrow);

        that.updateByOrigin($element, $hour, $minute);

        $upArrow.on('click', (e) => {
            e.preventDefault();
            that.changeEvent($element, $hour, $minute, 'up', 'minute')
        });

        $downArrow.on('click', (e) => {
            e.preventDefault();
            that.changeEvent($element, $hour, $minute, 'down', 'minute')
        });

        $element.on('change', (e) => {
            e.preventDefault();
            that.updateByOrigin($element, $hour, $minute)
        });

        $hour.on('change', (e) => {
            e.preventDefault();

            let value__hour = that.formatValue(that.getValue($hour), 'hour');
            let value__minute = that.formatValue(that.getValue($minute), 'minute');

            that.setValue($element, $hour, value__hour, $minute, value__minute);
        });

        $minute.on('change', (e) => {
            e.preventDefault();

            let value__hour = that.formatValue(that.getValue($hour), 'hour');
            let value__minute = that.formatValue(that.getValue($minute), 'minute');

            that.setValue($element, $hour, value__hour, $minute, value__minute);
        });

        $container.on('click', function (e) {
            if (e.target === e.currentTarget) {
                $hour.focus().select();
            }
        });

        $container.on('focus', '*', function () {
            $container.addClass('focus');
        });

        $container.on('focusout', '*', function () {
            $container.removeClass('focus');
        });

        $element.on('focus', function () {
            $hour.focus().select();
        });

        $hour.on('keydown', function (e) {
            if (e.keyCode === 40) {
                e.preventDefault();
                that.changeEvent($element, $hour, $minute, 'down', 'hour')
            } else if (e.keyCode === 38) {
                e.preventDefault();
                that.changeEvent($element, $hour, $minute, 'up', 'hour')
            }
        });

        $minute.on('keydown', function (e) {
            if (e.keyCode === 40) {
                e.preventDefault();
                that.changeEvent($element, $hour, $minute, 'down', 'minute')
            } else if (e.keyCode === 38) {
                e.preventDefault();
                that.changeEvent($element, $hour, $minute, 'up', 'minute')
            }
        });

    }

    updateByOrigin($element, $hour, $minute) {
        let that = this;

        let value__hour = that.formatValue(that.getDefaultValue($element, 'hour'), 'hour');
        let value__minute = that.formatValue(parseInt(that.getDefaultValue($element, 'minute')), 'minute');

        that.setValue($element, $hour, value__hour, $minute, value__minute);
    }

    changeEvent($element, $hour, $minute, direction, type) {
        let that = this;
        let value__hour = that.getValue($hour);
        let value__minute = that.getValue($minute);

        if (direction === 'up') {

            if (type === 'minute') {
                value__minute += 1;
            } else {
                value__hour += 1;
            }

            if (value__minute > 59) {
                value__minute = 0;
                value__hour += 1;
            }

            if (value__hour > 23) {
                value__minute = 0;
                value__hour = 0;
            }

        } else {

            if (type === 'minute') {
                value__minute -= 1;
            } else {
                value__hour -= 1;
            }

            if (value__minute < 0) {
                value__minute = 59;
                value__hour -= 1;
            }

            if (value__hour < 0) {
                value__minute = 59;
                value__hour = 23;
            }
        }

        value__hour = that.formatValue(value__hour, 'hour');
        value__minute = that.formatValue(value__minute, 'minute');

        that.setValue($element, $hour, value__hour, $minute, value__minute);
        $element.trigger("change");
    }

    setValue($element, $hour__element, value__hour, $minute__element, value__minute) {
        $hour__element.val(value__hour);
        $minute__element.val(value__minute);
        $element.val(value__hour + ":" + value__minute);
    }

    create__Container() {
        return $('<div class="inlineTimePicker"></div>');
    }

    create__Arrow(type) {
        return $('<button type="button" class="inlineTimePicker-arrow inlineTimePicker-arrow--' + type + '"></button>');
    }

    create__Input(type) {
        let out = false;

        if (type === 'hour') {
            out = $('<input class="inlineTimePicker-input inlineTimePicker-input--' + type + '" type="text">')
        } else if (type === 'minute') {
            out = $('<input class="inlineTimePicker-input inlineTimePicker-input--' + type + '" type="text">')
        } else if (type === 'dots') {
            out = $('<div class="inlineTimePicker-dots">:</div>')
        }

        return out;
    }

    getValue($element) {
        return parseInt($element.val());
    }

    getDefaultValue($element, type) {
        let that = this;
        let value = $element.val();
        let out = 0;

        if (value !== '') {
            if (type === 'hour') {
                out = that.validateValue(parseInt(value.split(":")[0]), 'hout');
            } else {
                out = that.validateValue(parseInt(value.split(":")[1]), 'minute');
            }
        }

        return out;
    }

    formatValue(value, type) {
        let that = this;
        let out = value = that.validateValue(value, type);

        if (type === 'hour') {
            if (value < 10) {
                out = '0' + value;
            }
        } else {
            if (value < 10) {
                out = '0' + value;
            }
        }

        return out;
    }

    validateValue(value, type) {
        let out = value;

        if (isNaN(value)) {
            out = 0;
        }

        if (type === 'hour') {
            if (value > 23) {
                out = 23;
            }
            if (value < 0) {
                out = 0;
            }
        } else {
            if (value > 59) {
                out = 59;
            }
            if (value < 0) {
                out = 0;
            }
        }
        return out;
    }
}